"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const NotFoundPage = () => {
    return ((0, jsx_runtime_1.jsxs)("main", Object.assign({ id: "notfound" }, { children: [(0, jsx_runtime_1.jsx)("p", Object.assign({ className: "title" }, { children: "Not Found" })), (0, jsx_runtime_1.jsx)("p", Object.assign({ className: "message" }, { children: "The requested URL was not found on this server." }))] })));
};
exports.NotFoundPage = NotFoundPage;
